/* eslint-disable @typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').directive('designerEdge', [
    function () {
      return {
        templateNamespace: 'svg',
        restrict: 'E',
        // eslint-disable-next-line global-require
        template: require('./designer-edge.html'),
        replace: true,
        scope: {
          edge: '=',
        },
        link(scope, element, attrs) {
          scope.edge.setElement(element);

          scope.$on('$destroy', function () {
            // scope.edge.destroy();
          });
        },
      };
    },
  ]);
})(window.angular);
